import DropdownMenu, { DropdownItemGroup } from '@atlaskit/dropdown-menu';
import React, { Ref, useState } from 'react';

import IssueCollector from '../../../../../../common/utils/issue-collectors';
import { Help } from '../../Buttons';
import { LinkItem } from '../DropdownItems';

export const DropdownItems = () => {
  const openInNewTabProps = {
    showShortcutIcon: true,
    target: '_blank',
    rel: 'noopener noreferrer',
  };
  return (
    <>
      <DropdownItemGroup title="Help">
        <LinkItem
          label="Frequently asked questions"
          href="https://www.atlassian.com/licensing/marketplace#general-faqs"
          {...openInNewTabProps}
        />
        <LinkItem
          label="Get support"
          href="https://support.atlassian.com/"
          {...openInNewTabProps}
        />
        <LinkItem
          label="Get started"
          href="https://developer.atlassian.com/platform/marketplace/getting-started/"
          {...openInNewTabProps}
        />
      </DropdownItemGroup>
      <DropdownItemGroup hasSeparator={true} title="Help us improve">
        <LinkItem
          label="Give feedback"
          onClick={(e: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element>) =>
            IssueCollector ? IssueCollector.showCollector(e) : undefined
          }
        />
      </DropdownItemGroup>
    </>
  );
};

export const HelpDropdown = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      setIsDropdownOpen(true);
    }
  };

  return (
    <DropdownMenu
      appearance="tall"
      placement="bottom-end"
      isOpen={isDropdownOpen}
      onOpenChange={({ isOpen }) => setIsDropdownOpen(isOpen)}
      trigger={({ triggerRef, ...props }) => (
        <Help
          triggerRef={triggerRef as Ref<HTMLDivElement>}
          handleKeyDown={handleKeyDown}
          {...props}
        />
      )}
    >
      <DropdownItems />
    </DropdownMenu>
  );
};
